__turbopack_context__.v({
  "banner": "_8dHgsW_banner",
  "col": "_8dHgsW_col",
  "img": "_8dHgsW_img",
  "sectionHeader": "_8dHgsW_sectionHeader",
  "subtitle": "_8dHgsW_subtitle",
  "title": "_8dHgsW_title",
  "top": "_8dHgsW_top",
  "top2": "_8dHgsW_top2",
  "wrapper": "_8dHgsW_wrapper",
});
